import React, { FC } from 'react';
import cnBind from 'classnames/bind';
import { IGetFlyingListRes } from '@/api/domains/FlyingListApi/interfaces/response';
import dayjs from 'dayjs';
import { GxIcon } from '@garpix/garpix-web-components-react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import { PencilIcon } from '@/assets';
import useModal from '@/hooks/useModal';
import { MODALS_NAMES } from '@/const/modals';
import styles from './styles/index.module.scss';
import { headerItem } from '../Schedule/const';
import { TableUserInfo } from './components/TableUserInfo';

interface ITableItem extends IGetFlyingListRes {
  handleClickModal: (date: string | null, info: Record<string, any> | null) => void;
}

const TableItem: FC<ITableItem> = ({
  start_at,
  comment,
  fly_list_entries,
  remaining_time,
  id,
  exit_time,
  entry_time,
}) => {
  const cn = cnBind.bind(styles);
  const { dispatch } = useStoreon<State, Events>();
  const { openModal } = useModal();

  const onChangeComment = (comment: string): void => {
    dispatch('flyingListTimeIntervals/update', { id, params: { comment } })
  }
  const openModalChangeComment = (comment: string): void => {
    openModal(MODALS_NAMES.modalCommentChange, { comment, onChangeComment });
  }
  return (
    <>
      <tr>
        {/* ВРЕМЯ НАЧАЛА start_at */}
        <td
          style={{ border: '1px solid #B0CBFF' }}
        >
          <div className={cn(styles.body_row__time__main, styles.order__container)}>
            <span>{dayjs(start_at).format('HH:mm')}</span>
          </div>
        </td>

        {/* ОСТАВШЕЕСЯ ВРЕМЯ remaining_time */}
        <td
          style={{ border: 'none' }}
          className={styles.body_row__header}
        >
          <div className={cn(styles.body_row__header__minutes, {
            'card': remaining_time !== 0,
          })}
          >
            <div className={styles.order__container}>
                <div
                  className={cn(styles.card__minutes, {
                    'card__minutes__restriction': remaining_time < 0
                  })}
                >
                  <span
                    className={cn(styles.card__minutes__text, {
                      'card__minutes__count': true
                    })}
                  >
                    {`${remaining_time} минут`}
                  </span>
                </div>
            </div>
          </div>
        </td>

        {/* КОММЕНТАРИЙ comment */}
        <td
          style={{ border: 'none' }}
          className={styles.body_column}
          colSpan={headerItem.length - 2}
        >
          <div className={styles.comment}>
            <p className={styles.comment__text}>
              {comment}
            </p>
            <GxIcon
              src={PencilIcon}
              className={cn({
                'comment__icon': true,
              })}
              onClick={() => {
                openModalChangeComment(comment);
              }}
            />
          </div>
        </td>
      </tr>

      {fly_list_entries.length !== 0 && fly_list_entries.map((item, index) => (
        <TableUserInfo
          key={item.id}
          isFirst={index === 0}
          intervalId={id}
          lengthFlyingEntries={fly_list_entries.length}
          exit_time={exit_time}
          entry_time={entry_time}
          {...item}
        />
      ))}
    </>
  );
};

export default TableItem;
